import { api } from '@cma/app'
import {
  AdminStatsQuery,
  AdminStatsQueryVariables
} from '@cma/generated/graphql'
import { useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useAdminStats(variables?: AdminStatsQueryVariables) {
  return useQuery<AdminStatsQuery, Error>(
    ['adminStats', variables?.brokerageId, variables?.officeId],
    () => {
      const query = gql`
        query AdminStats($brokerageId: ID, $officeId: ID) {
          stats: currentUser {
            platformClient {
              stats(brokerageId: $brokerageId, officeId: $officeId) {
                monthlyStats {
                  buyerActiveUsers
                  cmaActiveUsers
                  flyerActiveUsers
                  homebeatActiveUsers
                  month
                  propertyActiveUsers
                  totalActiveUsers
                  totalUsers
                  brokerageId
                  officeId
                  mls {
                    key
                    title
                  }
                }
              }
            }
          }
        }
      `
      return api<AdminStatsQuery, AdminStatsQueryVariables>({
        query,
        variables
      })
    },
    {
      retry: false
    }
  )
}
